import React from 'react'
import Postsalesguidecontent from './partials/postsalesguide'
import StaircaseComponent from './partials/staircase'
import SellingComponent from './partials/selling'

type Props = {
  data: Record<string, never>
};

const PostSalesGuide = (props: Props) => (
    <>
        {!!props.data['section-1'] && (
            <Postsalesguidecontent data={props.data['section-1']} />
        )}

        {!!props.data['section-2'] && (
            <StaircaseComponent data={props.data['section-2']} />
        )}

        {!!props.data['section-3'] && (
            <SellingComponent data={props.data['section-3']} />
        )}
    </>
);

export default PostSalesGuide